import { HANDLERS, INSTANCES } from '../constants/globals';

class InstanceListManager {
  // Create instance list with passed name
  constructor(instanceListName) {
    name: '';
    this.create(instanceListName);
  }

  create(instanceListName) {
    // Create the list if it isn't defined, or return the existing object
    if (INSTANCES[instanceListName] === undefined) {
      this.name = instanceListName;
      return INSTANCES[instanceListName] = new Object();
    } else {
      return INSTANCES[this.name];
    }
  }

  containsElement(instanceElement) {
    // Check if an element exists in the instanceList
    if (instanceElement.hasAttribute('id')) {
      let matches = Object.keys(INSTANCES[this.name]).filter((inst) => inst === instanceElement.id);
      return (matches.length) ? true : false;
    } else {
      return false;
    }
  }

  // Add an element to the instance list
  add(instanceId, instance) {
    INSTANCES[this.name][instanceId] = instance;
  }

  getGlobalList(name){
    return INSTANCES[this.name];
  }
}


export default InstanceListManager;
